module.exports = __webpack_public_path__ + "img/exit3_w.31d23fa5.svg";